import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { SecurityTokensToggleComponent } from "@modules/main/components/security-tokens/security-tokens-toggle/security-tokens-toggle.component";

@NgModule({
	declarations: [SecurityTokensToggleComponent],
	imports: [CoreModule],
	exports: [SecurityTokensToggleComponent]
})
export class SecurityTokensToggleModule {}
